import service from './server';
export default {
  login(params) { // 登录
    return service.post('api/adminUser/login', params);
  },
  codePicQuery() { // 查询图形验证码
    return 'api/adminUser/codePic';
  },
  smsSend(params) { // 发送验证码
    return service.post('api/adminUser/sendSms', params);
  },
  uploadImage() { // 图片上传
    return process.env.API_ROOT + 'api/file/uploadImg'
  },
  getQueryAllProvince(params){//获取地区
    return service.post('api/supplierGreightTemplate/queryAllProvince',params);
  },
  addGreightTemplate(params){// 新增接口
    return service.post('api/supplierGreightTemplate/addGreightTemplate',params);
  },
  editGreightTemplate(params){// 编辑接口
    return service.post('api/supplierGreightTemplate/editGreightTemplate',params);
  },
  listGreightTemplate(params){// 列表
    return service.post('api/supplierGreightTemplate/listGreightTemplate',params);
  },
  getEchoGreightTemplate(params){// 详情
    return service.post('api/supplierGreightTemplate/echoGreightTemplate',params);
  },
}



// WEBPACK FOOTER //
// ./src/server/index.js